import { render } from "./OrderDetailView.vue?vue&type=template&id=668ced42&scoped=true"
import script from "./OrderDetailView.vue?vue&type=script&lang=js"
export * from "./OrderDetailView.vue?vue&type=script&lang=js"

import "./OrderDetailView.vue?vue&type=style&index=0&id=668ced42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668ced42"]])

export default __exports__